import { makeStyles, Theme } from '@material-ui/core';
import { style } from 'commons/constants/KeyFlowConstants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: 0,
    backgroundColor: '#ffffff',
  },
  container: {
    // minHeight: '70px',
    [theme.breakpoints.down('md')]: {
      // minHeight: '55px',
    },
    padding: '16px 0 16px 0',
  },
  titleContainer: {
    // display: 'flex',
    // justifyContent: 'center',
    // alignContent: 'center',
    // '& > *': {
    //   fontWeight: 'bold',
    // },
    flexBasis: '145px',
    flexGrow: 0,
    [theme.breakpoints.down('md')]: {
      flex: '0 0 96px',
    },
    marginTop: '6px',
  },
  deselectionButtonContainer: {
    flexBasis: '118px',
    flexGrow: 0,
    [theme.breakpoints.down('md')]: {
      flex: '0 0 108px',
    },
  },
  filterContainer: {
    flex: '1 1 0',
    // padding: '10px 10px 10px 0',
    // paddingRight: '10px',
    marginRight: '16px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
  },
  season: {
    // overflow: 'hidden',

    width: '157px',
    height: '27px',

    marginTop: '5px',
    marginBottom: '5px',
    paddingLeft: '7px',
    paddingRight: '7px',
    marginRight: '6px',

    backgroundColor: 'transparent',
    border: 'none',

    fontSize: '16px',
    fontWeight: 'normal',

    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    // '&:not(:nth-child(6n))': {
    //   marginRight: '20px',
    // },
    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: style.PINK_COLOR,
    },
  },
  selected: {
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: style.PINK_COLOR,
    '&:hover': {
      color: '#ffffff',
      textDecoration: 'underline',
    },
  },
  deselectionButton: {
    '& img': {
      margin: '0 8px 0 0',
    },
  },
  dateContainer: {
    // '& > *': {
    //   margin: '0 10px 0 10px',
    // },
    marginRight: '16px',
  },
  dateInput: {
    // width: '145px', // 컴포넌트 적용전까지는 적용하면 크롬에서 잘려서 표시..
    height: '36px',
    textAlign: 'center',
    border: '1px solid #B6B6B6',
    borderRadius: 0,
    fontSize: '14px',
  },
  dateDelimiter: {
    width: '40px',
    display: 'inline-block',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
  inputPlayerNameContainer: {
    '& > *': {
      // margin: '0 10px 0 10px',
    },
  },
  inputPlayerName: {
    width: '100%',
    height: '36px',
    paddingLeft: '10px',
    paddingRight: '10px',
    textAlign: 'left',
    border: '1px solid #B6B6B6',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {},
  },
  selectedItemContainer: {
    padding: 0,
    listStyle: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
  searchButtonContainer: {
    minWidth: '120px',
    paddingRight: '15px',
    flexGrow: 0,
  },
  searchButton: {
    width: '120px',
    height: '36px',
    color: '#FFF',
    backgroundColor: '#D94F98',
    fontSize: '16px',
    fontWeight: 'bold',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#D94F98',
      opacity: 0.8,
    },
    '& img': {
      maxHeight: '16px',
    },
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  searchConditionContainer: {
    padding: 0,
    backgroundColor: 'rgba(255, 255, 255, 1.0)',
  },
  isActiveMenu: {
    backgroundColor: 'rgba(255, 255, 255, 1.0)',
    color: '#000000',
  },
  selectInput: {
    maxWidth: 'calc(100vw - 136px)',
    border: 'solid 1px #B6B6B6',
  },
  moreButton: {
    width: '36px',
    height: '36px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'lightgrey',
    },
    borderRadius: '9999px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'background-color 250ms, transform 250ms',
    marginRight: '20px',
  },
}));

export default useStyles;
